
<search-dropdown 
  [items]="categories" 
  [label]="'category_Name'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="onChanged($event)"
  [(ngModel)]="categoryId">
</search-dropdown>